import React from 'react';
import { Check, Settings, FileText, LayoutGrid, Sparkles, ImageIcon } from 'lucide-react';

export interface WizardStep {
  key: string;
  label: string;
  icon: typeof Settings;
}

export const WIZARD_STEPS: WizardStep[] = [
  { key: 'setup', label: 'Setup', icon: Settings },
  { key: 'brief', label: 'Brief', icon: FileText },
  { key: 'plan', label: 'Plan', icon: LayoutGrid },
  { key: 'generate', label: 'Generate', icon: Sparkles },
  { key: 'results', label: 'Results', icon: ImageIcon },
];

interface WizardStepperProps {
  currentStep: number;
  completedSteps: number[];
  onStepClick: (step: number) => void;
}

const WizardStepper: React.FC<WizardStepperProps> = ({ currentStep, completedSteps, onStepClick }) => {
  return (
    <div className="flex items-center justify-center gap-0 px-4 py-4">
      {WIZARD_STEPS.map((step, index) => {
        const stepNum = index + 1;
        const isCompleted = completedSteps.includes(stepNum);
        const isActive = currentStep === stepNum;
        const isClickable = isCompleted || isActive;
        const Icon = step.icon;

        return (
          <React.Fragment key={step.key}>
            {index > 0 && (
              <div className={`h-0.5 w-12 sm:w-20 transition-colors duration-300 ${
                completedSteps.includes(stepNum) || (isActive && index > 0 && completedSteps.includes(index))
                  ? 'bg-brand-purple'
                  : 'bg-gray-200'
              }`} />
            )}
            <button
              type="button"
              onClick={() => isClickable && onStepClick(stepNum)}
              disabled={!isClickable}
              className="flex flex-col items-center gap-1.5 group"
            >
              <div className={`flex h-10 w-10 items-center justify-center rounded-full border-2 transition-all duration-300 ${
                isCompleted
                  ? 'border-brand-purple bg-brand-purple text-white cursor-pointer hover:bg-brand-purple/90'
                  : isActive
                  ? 'border-brand-purple bg-white text-brand-purple shadow-md ring-4 ring-brand-purple/10'
                  : 'border-gray-200 bg-gray-50 text-gray-400 cursor-default'
              }`}>
                {isCompleted ? <Check className="h-4 w-4" /> : <Icon className="h-4 w-4" />}
              </div>
              <span className={`text-[11px] font-medium transition-colors hidden sm:block ${
                isActive ? 'text-brand-purple font-semibold' : isCompleted ? 'text-text-dark' : 'text-gray-400'
              }`}>
                {step.label}
              </span>
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default WizardStepper;
